import {
    Box,
    HStack,
    Icon,
    Image,
    Spinner,
    Text,
    Tooltip,
} from '@chakra-ui/react';
import { MdPhonelinkRing } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';

import ServiceProfileCard from 'components/v4/Cards/ServiceProfileCard/ServiceProfileCard';
import ServiceProfileCardTitle from 'components/v4/Cards/ServiceProfileCard/ServiceProfileCardTitle';
import walkthroughIds from 'pages/services/walkthroughIds';
import { axios } from 'services/axios';
import { useNavigateLocation } from 'hooks/useNavigateLocation/useNavigateLocation';

import path from '@/routes/constants';

import mobileLogo from 'assets/images/mobile.png';
import msTeamsLogo from 'assets/images/ms_teams_logo.png';

function TpmService({ serviceWizard, id }) {
    const queryClient = useQueryClient();
    const { ufNewServiceProfileCard } = walkthroughIds.dashboardServices;

    const { handleNavigateLocation: navigateLocation } = useNavigateLocation();
    const { currentPartner, currentCompany } = useSelector((state) => {
        return { ...state.navigationLists };
    });
    const { NUMBERS_TPM } = path;
    return (
        <ServiceProfileCard
            key={id}
            pointerEvents={serviceWizard.isCreatingService ? 'none' : 'auto'}
            onClick={() => {
                serviceWizard.setSelectedServiceProfile('TPM');
                serviceWizard.setIsCreatingService(true);
                serviceWizard.setHasCreateServiceError(null);
                return axios
                    .post(`/Service/TeamsPhoneMobile/Magic/${currentCompany}`)
                    .then((res) => {
                        navigateLocation(
                            `${NUMBERS_TPM}/${res.data.id}/activation`,
                        );
                        queryClient.invalidateQueries([
                            'services',
                            `company: ${currentCompany}`,
                        ]);
                        queryClient.invalidateQueries('getAssociatedAccounts');
                    })
                    .catch((e) => {
                        const message =
                            e?.response?.data?.message ||
                            'Error creating Teams Phone Mobile, Please Try Again.';
                        serviceWizard.setHasCreateServiceError(message);
                    });
            }}
            data-walkthroughid={`${ufNewServiceProfileCard}/${id}`}>
            {serviceWizard.isCreatingService && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'absolute',
                        height: '100%',
                        width: '100%',
                        left: '0',
                        top: '0',
                        background: 'white',
                        opacity: '0.7',
                    }}>
                    {serviceWizard.selectedServiceProfile === 'TPM' && (
                        <Spinner
                            thickness="4px"
                            emptyColor="gray.200"
                            color="brand.500"
                            size="xl"
                        />
                    )}
                </Box>
            )}
            <Box className="flex h-[120px] items-center justify-center">
                <Icon as={MdPhonelinkRing} fontSize={75} color="#4e57c0" />
            </Box>
            <ServiceProfileCardTitle>
                Teams Phone Mobile
            </ServiceProfileCardTitle>
            <Text>
                Enable Teams Phone Mobile connectivity. This requires a valid
                Operator Connect service to be deployed.
            </Text>
            {currentPartner == '100d5296-0c38-4192-1c43-08dbec03eb47' && (
                <HStack mt={'auto'}>
                    <Tooltip label="Microsoft">
                        <Image boxSize={'5'} src={msTeamsLogo} />
                    </Tooltip>
                    <Tooltip label="Mobile Calling">
                        <Image boxSize={'5'} src={mobileLogo} />
                    </Tooltip>
                </HStack>
            )}
        </ServiceProfileCard>
    );
}

export default TpmService;
